import { toast as sonnerToast } from "sonner"

type ToastVariant = 'default' | 'destructive' | 'success' | 'warning'

interface ToastOptions {
  title?: string
  description?: string
  variant?: ToastVariant
  duration?: number
}

// Compatibility shim: maps old toast({ title, description, variant }) calls
// to Sonner's API. Zero changes needed in consumer files.
function toast(opts: ToastOptions) {
  const message = opts.title || ""
  const options = {
    description: opts.description,
    duration: opts.duration,
  }

  switch (opts.variant) {
    case "destructive":
      return sonnerToast.error(message, options)
    case "success":
      return sonnerToast.success(message, options)
    case "warning":
      return sonnerToast.warning(message, options)
    default:
      return sonnerToast(message, options)
  }
}

function dismiss(toastId?: string | number) {
  sonnerToast.dismiss(toastId)
}

function useToast() {
  return { toast, dismiss, toasts: [] as never[] }
}

// Keep ToastProvider as a pass-through so existing <ToastProvider> wrappers
// don't break — it simply renders children with no context overhead.
function ToastProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}

export { useToast, ToastProvider, toast }
